// parseJwt.js
export function parseJwt(token) {
  if (!token) return {};

  // Token üç parçadan oluşur: header.payload.signature
  // Örneğin: eyJhbGciOiJ... (header). eyJzdWIiOiI... (payload). ...
  const base64Url = token.split('.')[1];
  if (!base64Url) return {};

  try {
    // URL-safe base64'ü normal base64'e dönüştürüp decode ediyoruz
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Token parse sırasında hata:', error);
    return {};
  }
}
